module.exports = __webpack_public_path__ + "/static/assets/87646ef2ba7e155fb27f5a075afb72c3.png";